<template lang="pug">
Card.card.brp-aside
  template(#title) Home upgrade roadmap
    span(v-tooltip="'The home upgrade roadmap is a tool that helps you design a customised step-by-step renovation plan for your home. It allows you to explore, organise, and schedule energy efficiency measures across multiple years — tailored to your building’s unique characteristics and your goals.'" class="pi pi-question-circle" style="margin-left: 0.5rem; margin-right: 0.5rem;")
  template(#content)
    div(v-if="!formComplete")
      span {{ !steps.length ? 'You haven’t created your home upgrade roadmap yet.' : 'You’re building your home upgrade plan. Review options and adjust decisions at your own pace.'}}
      .button(v-if="showActionButtons")
        Button.submit-button(
          :label="`${ !steps.length ? 'Start' : 'Continue'} home upgrade plan`"
          :icon="steps.length ? 'pi pi-arrow-right' : 'pi pi-home'"
          @click="openBRP"
        )
    div(v-else)
      .steps
          .step(v-for="step in steps" :key="step.step")
            .title Step {{ step.step }}
              span.separator ·
              | {{ step.year }}
            .items
              .item(v-for="item in step.items" :key="item.id")
                .name {{ item.title }}
            .cost {{formatNumberToString(getTotalCost(step.items))}}
      .button(v-if="showActionButtons")
        Button.submit-button(label="Download home upgrade roadmap" icon="pi pi-download" :loading="isGeneratingReport" @click="getReport()")
</template>
<script lang="ts" setup>
import Card from "primevue/card";
import Button from "primevue/button";
import {storeToRefs} from "pinia";
import {usePassport} from "@/store";
import {useRouter} from "vue-router";
import {formatNumberToString} from "@/helpers";

defineProps<{
  showActionButtons?: boolean
}>()

const router = useRouter()
const passportStore = usePassport()
const {formComplete, steps, isGeneratingReport} = storeToRefs(passportStore)

function openBRP() {
  router.push('/brp')
}

function getTotalCost(items) {
  return items.reduce(
      (s, i) => s + Number(i.cost.replace(/[^\d.-]/g, "")),
      0
  );
}
async function getReport() {
  try {
    passportStore.downloadGeneratedPdf()
  } catch (error) {
    console.error("Failed to download BRP report", error)
  }
}
</script>
<style lang="scss" scoped>
.brp-aside {
  .empty-state {
    p {
      color: $font-color-secondary;
      margin-bottom: 1rem;
    }
  }

  .steps {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  .step {
    .title {
      font-size: 1.1rem;
      display: flex;
      align-items: center;
      gap: 0.4rem;

      span.separator {
        font-weight: 900;
        font-size: 2rem;
      }
    }

    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 0.75rem;
    border-bottom: 1px solid $border-color;

    &:last-child {
      border-bottom: none;
    }
  }

  .step-header {
    font-size: 0.85rem;
    font-weight: 600;
    color: $secondary-color-hover;
    margin-bottom: 0.25rem;
  }

  .items {
    list-style: none;
    padding: 0;
    margin: 0 0 0.25rem 0;
    width: 50%;
    max-width: 50%;

    .item {
      font-size: 0.95rem;
      color: $font-color-default;
      line-height: 1.3;
    }
  }

  .cost {
    font-weight: 600;
    color: $primary-color;
    font-size: 0.95rem;
  }

  .button {
    margin-top: 1.25rem;
    display: flex;
    justify-content: center;
    align-items: center;
    &:deep(.p-button) {
      padding: 1rem 2.5rem;
    }
  }
}

</style>
